<ion-header>
  <ion-toolbar>
    <ion-button fill="clear" color="light" (click)="onClose($event)" class="btn-back-menu">
      <ion-icon color="dark" slot="start" name="arrow-back"></ion-icon>
      <!-- <strong style="color:black">{{ 'GLOBAL_BACK' | translate }}</strong> -->
    </ion-button>
    <ion-title class="text-large ion-text-bold ion-text-center">
      {{'ROUTE_PARTICIPANTS_TITLE' | translate}}
    </ion-title>
    <!-- <ion-label class="text-large ion-text-bold ion-text-center">{{'ROUTE_PARTICIPANTS_TITLE' | translate}}</ion-label> -->
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar type="text" (ionInput)="autocompleteKeyUp($event)"
      placeholder="{{'NEARBYEVENT_PARTICIPANT_SEARCH_NAME_FIELD' | translate}}" animated="true"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let participant of autoCompleteList" (click)="onParticipantSelect(participant)">
      <ion-icon slot="start" color="dark" name="add-circle-outline"></ion-icon>
      <ion-label>
        {{ participant.firstName }} {{ participant.lastName }}
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>


<ion-footer>
  <ion-item style="border-top: 1px solid grey;">
    <ion-input [(ngModel)]="email" placeholder="Email"></ion-input>
    <ion-button slot="end" (click)="invite()">
      {{ 'INVITE_SIMPLE' | translate }}
    </ion-button>
  </ion-item>
</ion-footer>